// extracted by mini-css-extract-plugin
export var lg = "_1l-4";
export var md = "_1l-3";
export var sm = "_1l-2";
export var xs = "_1l-1";
export var xxs = "_1l-0";